import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';
import { CollegeItem, InstitutionService } from '@edtech-ui/core/services/institution.service';

export interface CantFindCollegeModalData {
	firstName: string;
	lastName?: string;
	email: string;
}

@Component({
	selector: 'app-cant-find-college-modal',
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule],
	templateUrl: './cant-find-college-modal.component.html',
	styleUrl: './cant-find-college-modal.component.scss'
})
export class CantFindCollegeModalComponent {
	isSubmitting = false;

	collegeForm = new FormGroup({
		name: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]),
		abbreviation: new FormControl('', [Validators.maxLength(50)]),
		city: new FormControl('', [Validators.required, Validators.maxLength(100)]),
		state: new FormControl('', [Validators.required, Validators.maxLength(100)]),
		country: new FormControl({ value: 'India', disabled: true }, [Validators.required])
	});

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: CantFindCollegeModalData,
		private dialogRef: MatDialogRef<CantFindCollegeModalComponent>,
		private _institutionService: InstitutionService,
		private _toastr: ToastrService
	) {}

	closeDialogBox(): void {
		if (this.isSubmitting) return;
		this.dialogRef.close();
	}

	submit(): void {
		if (this.isSubmitting) return;

		if (this.collegeForm.invalid) {
			this.collegeForm.markAllAsTouched();
			return;
		}

		this.isSubmitting = true;
		const formValue = this.collegeForm.getRawValue();

		this._institutionService.requestNewCollege({
			first_name: this.data.firstName,
			last_name: this.data.lastName,
			email: this.data.email,
			name: (formValue.name || '').trim(),
			abbreviation: (formValue.abbreviation || '').trim() || null,
			city: (formValue.city || '').trim(),
			state: (formValue.state || '').trim(),
			country: 'India'
		}).pipe(
			finalize(() => { this.isSubmitting = false; })
		).subscribe({
			next: (res) => {
				if (res?.Success && res?.Data) {
					this._toastr.success(res.Message || 'College submitted successfully.');
					this.dialogRef.close(res.Data as CollegeItem);
				} else {
					this._toastr.error(res?.Message || 'Could not submit the college. Please try again.');
				}
			},
			error: (err) => {
				this._toastr.error(err?.error?.Message || 'Could not submit the college. Please try again.');
			}
		});
	}
}
